import axios from "axios";

import {
  reducerSingleReportSettingsOptions,
  reducerUserSingleReport,
  reducerAggregateReport,
  reducerCriteriasList,
  reducerReportStatus,
  reducerTechCardData,
  reducerTunderSignals,
} from "../../reducer/userSingleReport/reducers/userSingleReport";
import { reducerReportsStatus } from "../../reducer/userReports/reducers/userReports";
import { AppDispatch } from "../../reducer/store";
import { getToken } from "../axiosToken";

interface ITunderSignalsOptions {
  contractId: number;
  posId: number;
  date: string;
};

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const actionGetUserSingleReport =
  (reportId: string) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    try {
      const response = await axios.get(`${BASE_URL}/json/reports/${reportId}`);

      dispatch(reducerUserSingleReport({ data: response.data }));
    } catch {
      console.log('err');
    };
  };

export const actionShowTunderSignal =
  (data: ITunderSignalsOptions) => async (dispatch: AppDispatch, getState: () => any) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    const { contractId, posId, date } = data;

    const store = getState();
    const signals =
      store.userSingleReport.userSingleReport?.tunderSignals || [];
    try {
      const response = await axios.get(
        `${BASE_URL}/json/tander/completedSignal?contractId=${contractId}&posId=${posId}&date=${date}`
      );

      dispatch(reducerTunderSignals({ status: response.data, signals: signals }));
    } catch {
      console.log('err');
    };
  };

export const actionGetTunderSignals =
  (data: ITunderSignalsOptions) => async (dispatch: AppDispatch, getState: () => any) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    const { contractId, posId, date } = data;

    const store = getState();
    const signalsStatus =
      store.userSingleReport.userSingleReport?.isVisibleTunderSignals;
    try {
      const response = await axios.get(
        `${BASE_URL}/json/tander/completedSignals?contractId=${contractId}&posId=${posId}&date=${date}`
      );

      dispatch(
        reducerTunderSignals({ status: signalsStatus, signals: response.data })
      );
    } catch {
      console.log('err');
    };
  };

export const actionGetCriteriasList =
  (contract: number) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    try {
      const response = await axios.get(
        `${BASE_URL}/json/contracts/criterias/list/${contract}`
      );
      dispatch(reducerCriteriasList(response.data));
    } catch (err) {
      console.log(err);
    }
  };

export const actionAcceptRate =
  (data: any, requestLocation?: string) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    try {
      const response = await axios.post(
        `${BASE_URL}/json/reports/rate/accept`,
        {
          ...data,
        }
      );

      dispatch(reducerUserSingleReport({ data: response.data }));
      if (requestLocation === "reportCheckBtn") {
        dispatch(
          reducerReportStatus({
            status: response.status,
            requestPurpose: "clientReportCheck",
          })
        );
      }
    } catch (err: any) {
      if (requestLocation === "reportCheckBtn") {
        dispatch(
          reducerReportStatus({
            status: err.response.status === 400 ? 1 : 0,
            requestPurpose: "clientReportCheck",
          })
        );
      }
    }
  };

export const actionDeclineRate =
  (data: {
    reportId: {
      id: number;
      name?: string | undefined;
    },
    rateNote: string;
    weigth?: number | undefined;
    checkType?: string | undefined;
  }) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    try {
      const response = await axios.post(
        `${BASE_URL}/json/reports/rate/decline`,
        {
          ...data,
        }
      );

      dispatch(reducerUserSingleReport({ data: response.data }));
    } catch (err) { }
  };

export const actionApproveReport =
  (data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    try {
      const response = await axios.post(
        `${BASE_URL}/json/reports/review/approve`,
        {
          ...data,
        }
      );

      dispatch(reducerUserSingleReport({ data: response.data }));
    } catch (err) { }
  };

export const actionRejectReport =
  (data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    try {
      const response = await axios.post(
        `${BASE_URL}/json/reports/review/reject`,
        {
          ...data,
        }
      );

      dispatch(reducerUserSingleReport({ data: response.data }));
    } catch (err) { }
  };

export const actionRevisionReport = (data: any) => async () => {
  const { token } = await getToken();
  axios.defaults.headers.common["Authorization"] = token;

  try {
    await axios.post(`${BASE_URL}/json/reports/review/revision`, {
      ...data,
    });
  } catch (err) { }
};

export const actionCancelReportReview =
  (id: string) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    try {
      const response = await axios.post(
        `${BASE_URL}/json/reports/review/cancel/${id}`
      );

      dispatch(reducerUserSingleReport({ data: response.data }));
    } catch (err) { }
  };

export const actionReviewByCheck =
  (data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    try {
      const response = await axios.post(
        `${BASE_URL}/json/reports/review/byCheck`,
        {
          ...data,
        }
      );

      dispatch(reducerUserSingleReport({ data: response.data }));
    } catch (err) {
      alert(err);
    }
  };

export const actionCopyReport =
  (data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    try {
      const response = await axios.post(`${BASE_URL}/json/reports/copy`, {
        ...data,
      });

      dispatch(
        reducerReportStatus({
          status: response.status,
          requestPurpose: "copy",
        })
      );
    } catch (err) {
      dispatch(
        reducerReportStatus({
          status: 0,
          requestPurpose: "copy",
        })
      );
    }
  };

export const actionDeleteReport =
  (id: string) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    try {
      const response = await axios.delete(
        `${BASE_URL}/json/reports/delete/${id}`
      );

      dispatch(
        reducerReportsStatus({
          reportsStatus: response.status,
          reportsRequestPurpose: "delete",
        })
      );
    } catch (err) {
      dispatch(
        reducerReportsStatus({
          reportsStatus: 0,
          reportsRequestPurpose: "delete",
        })
      );
    }
  };

export const actionDeleteReportPhotos =
  (data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    try {
      const response = await axios.post(
        `${BASE_URL}/json/reports/${data.reportId}/media/delete`,
        ...data.medias
      );

      dispatch(reducerUserSingleReport({ data: response.data }));
      dispatch(
        reducerReportStatus({
          status: response.status,
          requestPurpose: "deletePhotos",
        })
      );
    } catch (err) {
      dispatch(
        reducerReportStatus({
          status: 0,
          requestPurpose: "deletePhotos",
        })
      );
    }
  };

export const actionRenamePhotoCard =
  (data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    const response = await axios.patch(
      `${BASE_URL}/json/reports/${data.reportId}/media/update`,
      data.medias
    );

    dispatch(reducerUserSingleReport({ data: response.data }));
  };

export const actionClientDeclineReport =
  (data: any, files: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    const headers = {
      Authorization: token,
      "Content-Type": "multipart/form-data",
    };
    const formData = new FormData();
    const jsonData = JSON.stringify(data);

    formData.append(
      "model",
      new Blob([jsonData], { type: "application/json" })
    );
    files.forEach((file: any) => {
      formData.append("picture", file, file.name);
    });

    try {
      const response = await axios.post(
        `${BASE_URL}/json/reports/claim/declineRequest`,
        formData,
        {
          headers: headers,
        }
      );

      dispatch(reducerUserSingleReport({ data: response.data }));
    } catch (err) {
      dispatch(
        reducerReportStatus({
          status: 0,
          requestPurpose: "declineRateStatus",
        })
      );
    }
  };

export const actionClientAcceptReport =
  (data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    const headers = {
      Authorization: token,
    };

    try {
      const response = await axios.post(
        `${BASE_URL}/json/reports/rate/accept`,
        data,
        {
          headers: headers,
        }
      );

      dispatch(reducerUserSingleReport({ data: response.data }));
    } catch (err) { }
  };

export const actionClientRequestReport =
  (data: any, files?: any, requestLocation?: string) =>
    async (dispatch: AppDispatch) => {
      const { token } = await getToken();
      const headers = {
        Authorization: token,
        "Content-Type": "multipart/form-data",
      };
      const formData = new FormData();
      const jsonData = JSON.stringify(data);

      formData.append(
        "model",
        new Blob([jsonData], { type: "application/json" })
      );
      files.forEach((file: any) => {
        formData.append("picture", file, file.name);
      });

      try {
        const response = await axios.post(
          `${BASE_URL}/json/reports/claim/request`,
          formData,
          {
            headers: headers,
          }
        );

        dispatch(reducerUserSingleReport({ data: response.data }));

        if (requestLocation === "reportCheckBtn") {
          dispatch(
            reducerReportStatus({
              status: response.status,
              requestPurpose: "clientReportCheck",
            })
          );
        }
      } catch (err) {
        if (requestLocation === "reportCheckBtn") {
          dispatch(
            reducerReportStatus({
              status: 0,
              requestPurpose: "clientReportCheck",
            })
          );
        }
      }
    };

export const actionGetTechCardData =
  (posId: string) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    try {
      const response = await axios.get(`${BASE_URL}/json/pos/checklist/${posId}`);

      dispatch(reducerTechCardData(response.data));
    } catch {
      console.log('err');
    };
  };

export const actionConfirmReportClaim =
  (data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    try {
      const response = await axios.post(
        `${BASE_URL}/json/reports/claim/confirm`,
        data
      );

      dispatch(reducerUserSingleReport({ data: response.data }));
    } catch (err) {
      alert(err);
    }
  };

export const actionDeclineReportClaim =
  (data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    try {
      const response = await axios.post(
        `${BASE_URL}/json/reports/claim/decline`,
        data
      );

      dispatch(reducerUserSingleReport({ data: response.data }));
    } catch (err) {
      alert(err);
    }
  };

export const actionUpdateNotesClaim =
  (data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    try {
      const response = await axios.post(
        `${BASE_URL}/json/reports/claim/note`,
        data
      );

      dispatch(reducerUserSingleReport({ data: response.data }));
    } catch (err) {
      alert(err);
    }
  };

export const actionCancelReportClaim =
  (data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    try {
      const response = await axios.post(
        `${BASE_URL}/json/reports/rate/cancel`,
        data
      );

      dispatch(reducerUserSingleReport({ data: response.data }));
    } catch (err) { }
  };

export const actionUpdateSkuAction =
  (data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    try {
      const response = await axios.patch(
        `${BASE_URL}/json/reports/${data.reportId}/update/actionSku`,
        data.data
      );

      dispatch(reducerUserSingleReport({ data: response.data }));
      dispatch(reducerReportStatus({ status: 200, requestPurpose: 'changeHotline' }));
    } catch (err) {
      if (err instanceof Error) {
        dispatch(reducerReportStatus({ status: 0, requestPurpose: 'changeHotline' }));
      }
    }
  };

export const actionUpdateReportAction =
  (data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    try {
      const response = await axios.patch(
        `${BASE_URL}/json/reports/${data.reportId}/update/action`,
        data.data
      );

      dispatch(reducerUserSingleReport({ data: response.data }));
      dispatch(reducerReportStatus({ status: 200, requestPurpose: 'changeHotline' }));
    } catch (err) {
      if (err instanceof Error) {
        dispatch(reducerReportStatus({ status: 0, requestPurpose: 'changeHotline' }));
      }
    }
  };

export const actionUpdateReportItem =
  (data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    try {
      const response = await axios.patch(
        `${BASE_URL}/json/reports/${data.reportId}/update/item`,
        data.data
      );

      dispatch(reducerUserSingleReport({ data: response.data }));
      // dispatch(
      //   reducerReportStatus({
      //     status: response.status,
      //     requestPurpose: "changeHotline",
      //   })
      // );
    } catch {
      console.log('err');
    };
  };

export const actionUpdateReportCv =
  (data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    try {
      const response = await axios.patch(
        `${BASE_URL}/json/reports/${data.reportId}/update/cv`,
        data.data
      );

      dispatch(reducerUserSingleReport({ data: response.data }));
      dispatch(reducerReportStatus({ status: 200, requestPurpose: 'changeHotline' }));
    } catch (err) {
      if (err instanceof Error) {
        dispatch(reducerReportStatus({ status: 0, requestPurpose: 'changeHotline' }));
      }
    }
  };

export const actionUpdateReportSkuCv =
  (data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    try {
      const response = await axios.patch(
        `${BASE_URL}/json/reports/${data.reportId}/update/skuCv`,
        data.data
      );

      dispatch(reducerUserSingleReport({ data: response.data }));
    } catch {
      console.log('err');
    };
  };

export const actionUpdateFixDate =
  (data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    try {
      const response = await axios.post(
        `${BASE_URL}/json/reports/claim/expectedFixDate`,
        data
      );

      dispatch(reducerUserSingleReport({ data: response.data }));
    } catch {
      console.log('err');
    };
  };

export const actionUpdateReportNotes =
  (data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    try {
      const response = await axios.patch(
        `${BASE_URL}/json/reports/${data.reportId}/update/notes`,
        { ...data.data }
      );

      dispatch(reducerUserSingleReport({ data: response.data }));
    } catch {
      console.log('err');
    };
  };

export const actionSetSingleReportSettings =
  (key: string, entity: any) => async () => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    axios.post(`${BASE_URL}/json/auth/config/update?key=${key}`, {
      entity,
    });
  };

export const actionGetSingleReportSettings =
  (key: string) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    try {
      const response = await axios.get(`${BASE_URL}/json/auth/config?key=${key}`);

      dispatch(reducerSingleReportSettingsOptions(response.data));
    } catch {
      console.log('err');
    };
  };

export const actionGetAgregateReportItem =
  (id: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    try {
      const response = await axios.get(
        `${BASE_URL}/json/reports/aggregate/${id}`,
      );

      dispatch(reducerAggregateReport({ data: response.data }));
    } catch {
      console.log('err');
    };
  };

export const actionDownloadNewPhotos =
  (data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    const headers = {
      Authorization: token,
      "Content-Type": "multipart/form-data",
    };
    
    const formData = new FormData();
    
    const photoPrefix =
      data.category === 'SkuBefore'
        ? 'Фото до'
        : data.category === 'SkuAfter'
          ? 'Фото после'
          : '';
    
    data.files.forEach((file: File, index: number) => {

      const baseName = data.productName || file.name;
      const newFileName =
        data.files.length > 1
          ? `${photoPrefix} ${baseName}_${index + 1}`
          : `${photoPrefix} ${baseName}`;
      formData.append("files", file, newFileName);
    });
    
    let typeParam = '';
    if (data.category === 'SkuBefore') {
      typeParam = '0';
    } else if (data.category === 'SkuAfter') {
      typeParam = '1';
    }
    const params = new URLSearchParams();
    if (data.revision !== undefined && data.revision !== null) {
      params.append("revision", data.revision);
    }
    if (data.skuId !== undefined && data.skuId !== null) {
      params.append("skuId", data.skuId);
    }
    if (data.category !== undefined && data.category !== null) {
      params.append("category", data.category);
    }
    if (typeParam !== "") {
      params.append("type", typeParam);
    }
    
    const reportId = data.reportId || "";
    
    try {
      const url = `${BASE_URL}/json/reports/${reportId}/files/add?${params.toString()}`;
      const response = await axios.put(url, formData, { headers });
      
      dispatch(reducerUserSingleReport({ data: response.data }));
      dispatch(
        reducerReportStatus({
          status: response.status,
          requestPurpose: "addPhotos",
        })
      );
    } catch (err) {
      dispatch(
        reducerReportStatus({
          status: 0,
          requestPurpose: "addPhotos",
        })
      );
    }
  };

export const actionDeleteTablePhotos = (data: any) => async (dispatch: AppDispatch) => {
  const { token } = await getToken();
  axios.defaults.headers.common["Authorization"] = token;
  const mediasPayload = Array.isArray(data.medias)
    ? data.medias.map((mediaId: number) => ({ id: mediaId }))
    : data.medias;
  
  try {
    const response = await axios.post(
      `${BASE_URL}/json/reports/${data.reportId}/media/delete`,
      JSON.stringify(mediasPayload),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );
    
    dispatch(reducerUserSingleReport({ data: response.data }));
    dispatch(
      reducerReportStatus({
        status: response.status,
        requestPurpose: "deletePhotos",
      })
    );
  } catch (err) {
    dispatch(
      reducerReportStatus({
        status: 0,
        requestPurpose: "deletePhotos",
      })
    );
  }
};

export const mapPosStatusToName = (status: number | undefined): string => {
    let s = "—"
    if (status !== undefined && status !== null) {
        switch (status) {
            case 0:
                s = "Закрыта навсегда";
                break;
            case 1:
                s = "Закрыта на ремонт до";
                break;
            case 2:
                s = "Отсутствует лицензия на алкоголь";
                break;
            case 3:
                s = "Неадекватное руководство ТТ";
                break;
            case 4:
                s = "Запрещено перемещение между отделами";
                break;
            case 5:
                s = "Дубль";
                break;
            case 6:
                s = "Активная";
                break;
            case 7:
                s = "Техническая ТТ";
                break;
        }
    }
    return s;
};